import * as React from 'react';
import { Button } from '@mui/material';
import { TerminalCredential } from 'services/clients/credentials';

interface Props {
  credential: TerminalCredential;
  onCreate: (credential: TerminalCredential) => void;
}

export const AddButton: React.FC<Props> = (props) => {
  const { credential, onCreate } = props;
  return (
    <div>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          onCreate(credential);
        }}
        variant="outlined"
        size="medium"
      >
        <h4>+ Add Credential</h4>
      </Button>
    </div>
  );
};
